import AppResource from './AppResource'
import GoHomeBackgroundScreen from 'assets/images/img_signin_bg_gohoadon.jpg'

const BaseConfig = {
  localhost: {
    logo: AppResource.branding.vietinvoice_logo,
    secondLogo: AppResource.images.img_ICORP_logo,
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.branding.vietinvoice_ico,
    },
    name: 'VIETINVOICE',
    menubar: [
      {
        translateText: 'Introduction',
        link: 'https://vietinvoice.vn/gioi-thieu',
      },
      {
        translateText: 'Price list',
        link: 'https://vietinvoice.vn/bang-gia',
      },
      {
        translateText: 'Invoice template',
        link: 'https://vietinvoice.vn/mau-hoa-don',
      },
      {
        translateText: 'Document',
        link: 'https://vietinvoice.vn/van-ban',
      },
      {
        translateText: 'Customer',
        link: 'https://vietinvoice.vn/khach-hang',
      },
      {
        translateText: 'News',
        link: 'https://vietinvoice.vn/tin-tuc',
      },
      {
        translateText: 'Contact',
        link: 'https://vietinvoice.vn/lien-he',
      },
    ],
    introduceText: {
      title: 'Giải pháp hóa đơn điện tử an toàn và thông minh',
      content:
        'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
    },
    serviceCustomerPhone: [
      { label: '1900.4751', value: '19004751' },
      { label: '0208.3607.668', value: '02083607668' },
    ],
    header: {
      userManual: true, // Hướng dẫn sử dụng
      cart: true, // Giỏ hàng
    },
    services: {
      invoice: true, // Hóa đơn
      ticket: true, // Vé điện tử
      receipt: true, // biên lai thu phí, lệ phí
      incommingInvoiceProcess: true, // Quản lý hóa đơn đầu vào
      personalIncomeTax: true, // Chứng từ thu nhập cá nhân
      eContract: true, // Hợp đồng điện tử
    },
    footer: {
      isHadFooter: true,
      content: {
        companyName: 'CÔNG TY CỔ PHẦN ICORP',
        address:
          'Tầng 3, số 112, phố Dịch Vọng Hậu, phường Dịch Vọng Hậu, quận Cầu Giấy TP Hà Nội',
        hotline: '1900.0099',
      },
    },
  },
  'petro.vietinvoice.vn': {
    logo: AppResource.branding.vietinvoice_logo,
    secondLogo: AppResource.images.img_ICORP_logo,
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.branding.vietinvoice_ico,
    },
    name: 'VIETINVOICE',
    menubar: [
      {
        translateText: 'Introduction',
        link: 'https://vietinvoice.vn/gioi-thieu',
      },
      {
        translateText: 'Price list',
        link: 'https://vietinvoice.vn/bang-gia',
      },
      {
        translateText: 'Invoice template',
        link: 'https://vietinvoice.vn/mau-hoa-don',
      },
      {
        translateText: 'Document',
        link: 'https://vietinvoice.vn/van-ban',
      },
      {
        translateText: 'Customer',
        link: 'https://vietinvoice.vn/khach-hang',
      },
      {
        translateText: 'News',
        link: 'https://vietinvoice.vn/tin-tuc',
      },
      {
        translateText: 'Contact',
        link: 'https://vietinvoice.vn/lien-he',
      },
    ],
    introduceText: {
      title: 'Giải pháp hóa đơn điện tử an toàn và thông minh',
      content:
        'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
    },
    serviceCustomerPhone: [
      { label: '1900.0099', value: '19000099' },
      { label: '0988.399.516', value: '0988399516' },
    ],
    services: {
      invoice: true, // Hóa đơn
      ticket: true, // Vé điện tử
      receipt: true, // biên lai thu phí, lệ phí
      incommingInvoiceProcess: true, // Quản lý hóa đơn đầu vào
      personalIncomeTax: true, // Chứng từ thu nhập cá nhân
      eContract: true, // Hợp đồng điện tử
    },
    footer: {
      isHadFooter: true,
      content: {
        companyName: 'CÔNG TY CỔ PHẦN ICORP',
        address:
          'Tầng 5, Toà nhà SANNAM, Số 78 Phố Duy Tân, Phường Cầu Giấy, Thành Phố Hà Nội',
        hotline: '1900.0099',
      },
    },
    header: {
      // bannerImg: AppResource.images.header.petroBanner,
      userManual: true, // Hướng dẫn sử dụng
      cart: true, // Giỏ hàng
    },
  },
  'hoadondientu.vietinvoice.vn': {
    buildVersion: 'Phiên bản 2026.1105.1345',
    logo: AppResource.branding.vietinvoice_logo,
    secondLogo: AppResource.images.img_ICORP_logo,
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.branding.vietinvoice_ico,
    },
    name: 'VIETINVOICE',
    menubar: [
      {
        translateText: 'Introduction',
        link: 'https://vietinvoice.vn/gioi-thieu',
      },
      {
        translateText: 'Price list',
        link: 'https://vietinvoice.vn/bang-gia',
      },
      {
        translateText: 'Invoice template',
        link: 'https://vietinvoice.vn/mau-hoa-don',
      },
      {
        translateText: 'Document',
        link: 'https://vietinvoice.vn/van-ban',
      },
      {
        translateText: 'Customer',
        link: 'https://vietinvoice.vn/khach-hang',
      },
      {
        translateText: 'News',
        link: 'https://vietinvoice.vn/tin-tuc',
      },
      {
        translateText: 'Contact',
        link: 'https://vietinvoice.vn/lien-he',
      },
    ],
    introduceText: {
      title: 'Giải pháp hóa đơn điện tử an toàn và thông minh',
      content:
        'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
    },
    serviceCustomerPhone: [
      { label: '1900.0099', value: '19000099' },
      { label: '0988.399.516', value: '0988399516' },
    ],
    header: {
      userManual: true, // Hướng dẫn sử dụng
      cart: true, // Giỏ hàng
    },
    services: {
      invoice: true, // Hóa đơn
      ticket: true, // Vé điện tử
      receipt: true, // biên lai thu phí, lệ phí
      incommingInvoiceProcess: true, // Quản lý hóa đơn đầu vào
      personalIncomeTax: true, // Chứng từ thu nhập cá nhân
      eContract: true, // Hợp đồng điện tử
    },
    systemTab: {
      autoConfig: false, // tắt tab Cấu hình tự động
    },
    footer: {
      isHadFooter: true,
      content: {
        companyName: 'CÔNG TY CỔ PHẦN ICORP',
        address:
          'Tầng 5, Toà nhà SANNAM, Số 78 Phố Duy Tân, Phường Cầu Giấy, Thành Phố Hà Nội',
        hotline: '1900.0099',
      },
    },
  },
  'tuluc.vietinvoice.vn': {
    logo: AppResource.branding.tuluc_ico,
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.branding.tuluc_ico,
    },
    name: 'TỰ LỰC',
    menubar: [],
    introduceText: {
      title: 'Giải pháp hóa đơn điện tử an toàn và thông minh',
      content:
        'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
    },
    serviceCustomerPhone: [
      { label: '1900.0099', value: '19000099' },
      { label: '0988.399.516', value: '0988399516' },
    ],
    header: {
      userManual: true, // Hướng dẫn sử dụng
      cart: true, // Giỏ hàng
    },
    services: {
      invoice: true, // Hóa đơn
      ticket: true, // Vé điện tử
      receipt: true, // biên lai thu phí, lệ phí
      incommingInvoiceProcess: true, // Quản lý hóa đơn đầu vào
      personalIncomeTax: true, // Chứng từ thu nhập cá nhân
      eContract: true, // Hợp đồng điện tử
    },
  },
  'seen.vietinvoice.vn': {
    logo: AppResource.branding.seen_logo,
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.branding.seen_logo,
    },
    name: 'SEEN',
    menubar: [],
    introduceText: {
      title: 'Giải pháp hóa đơn điện tử seen',
      content:
        'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
    },
    serviceCustomerPhone: [
      { label: '1900.0099', value: '19000099' },
      { label: '0988.399.516', value: '0988399516' },
    ],
    header: {
      userManual: true, // Hướng dẫn sử dụng
      cart: true, // Giỏ hàng
    },
    services: {
      invoice: true, // Hóa đơn
      ticket: true, // Vé điện tử
      receipt: true, // biên lai thu phí, lệ phí
      incommingInvoiceProcess: true, // Quản lý hóa đơn đầu vào
      personalIncomeTax: true, // Chứng từ thu nhập cá nhân
      eContract: true, // Hợp đồng điện tử
    },
  },
  'phusan.vietinvoice.vn': {
    logo: AppResource.branding.vietinvoice_logo,
    // secondLogo: AppResource.images.img_ICORP_logo,
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.branding.vietinvoice_ico,
    },
    name: 'VIETINVOICE',
    menubar: [],
    introduceText: {
      title: 'Giải pháp hóa đơn điện tử an toàn và thông minh',
      content:
        'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
    },
    serviceCustomerPhone: [
      { label: '1900.4751', value: '19004751' },
      { label: '0208.3607.668', value: '02083607668' },
    ],
    header: {
      userManual: true, // Hướng dẫn sử dụng
      cart: true, // Giỏ hàng
    },
    services: {
      invoice: true, // Hóa đơn
      ticket: true, // Vé điện tử
      receipt: true, // biên lai thu phí, lệ phí
      incommingInvoiceProcess: true, // Quản lý hóa đơn đầu vào
      personalIncomeTax: true, // Chứng từ thu nhập cá nhân
      eContract: true, // Hợp đồng điện tử
    },
    // footer: {
    //   isHadFooter: true,
    //   content: {
    //     companyName: 'CÔNG TY CỔ PHẦN ICORP',
    //     address:
    //       'Tầng 3, số 112, phố Dịch Vọng Hậu, phường Dịch Vọng Hậu, quận Cầu Giấy TP Hà Nội',
    //     hotline: '1900.0099',
    //   },
    // },
  },
  'uatphusan.vietinvoice.vn': {
    logo: AppResource.branding.vietinvoice_logo,
    // secondLogo: AppResource.images.img_ICORP_logo,
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.branding.vietinvoice_ico,
    },
    name: 'VIETINVOICE',
    menubar: [],
    introduceText: {
      title: 'Giải pháp hóa đơn điện tử an toàn và thông minh',
      content:
        'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
    },
    serviceCustomerPhone: [
      { label: '1900.4751', value: '19004751' },
      { label: '0208.3607.668', value: '02083607668' },
    ],
    header: {
      userManual: true, // Hướng dẫn sử dụng
      cart: true, // Giỏ hàng
    },
    services: {
      invoice: true, // Hóa đơn
      ticket: true, // Vé điện tử
      receipt: true, // biên lai thu phí, lệ phí
      incommingInvoiceProcess: true, // Quản lý hóa đơn đầu vào
      personalIncomeTax: true, // Chứng từ thu nhập cá nhân
      eContract: true, // Hợp đồng điện tử
    },
    // footer: {
    //   isHadFooter: true,
    //   content: {
    //     companyName: 'CÔNG TY CỔ PHẦN ICORP',
    //     address:
    //       'Tầng 3, số 112, phố Dịch Vọng Hậu, phường Dịch Vọng Hậu, quận Cầu Giấy TP Hà Nội',
    //     hotline: '1900.0099',
    //   },
    // },
  },
  'hoadon.igas.vn': {
    logo: AppResource.branding.igas_logo,
    // secondLogo: AppResource.images.img_ICORP_logo,
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.branding.igas_ico,
    },
    name: 'IGAS',
    serviceProviderTaxCode: '0111090707',
    menubar: [],
    introduceText: {
      title: 'Giải pháp hóa đơn điện tử an toàn và thông minh',
      content:
        'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
    },
    serviceCustomerPhone: [{ label: '1900.9110', value: '19009110' }],
    header: {
      userManual: false, // Hướng dẫn sử dụng
      cart: false, // Giỏ hàng
    },
    services: {
      invoice: true, // Hóa đơn
      ticket: false, // Vé điện tử
      receipt: false, // biên lai thu phí, lệ phí
      incommingInvoiceProcess: false, // Quản lý hóa đơn đầu vào
      personalIncomeTax: false, // Chứng từ thu nhập cá nhân
      eContract: false, // Hợp đồng điện tử
    },
    footer: {
      isHadFooter: true,
      content: {
        companyName: 'CÔNG TY CỔ PHẦN GIẢI PHÁP SỐ IGAS',
        address:
          'Biệt thự A3-14, đường Hà Phong 3, khu đô thị Hà Phong, xã Mê Linh, thành phố Hà Nội, Việt Nam',
        hotline: '1900.9110',
      },
    },
    invoiceTemplateFooter:
      'Phát hành bởi phần mềm hoadon.igas.vn - CÔNG TY CỔ PHẦN GIẢI PHÁP SỐ IGAS',
  },
  'hoadon.gohoadon.vn': {
    // localhost: {
    buildVersion: '',
    logo: AppResource.branding.go_logo,
    // secondLogo: AppResource.images.go_logo,
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.branding.go_ico,
    },
    name: 'GO',
    serviceProviderTaxCode: '0111245245',
    menubar: [],
    introduceText: {
      title: 'Hệ thống hóa đơn điện tử bảo mật cao, xử lý linh hoạt',
      content:
        'Trải nghiệm hệ thống hóa đơn thế hệ mới. Chúng tôi tin bạn sẽ nhận được nhiều hơn kỳ vọng. Hãy khám phá ngay.',
      background: GoHomeBackgroundScreen,
      signInBtnColor: 'red',
    },
    serviceCustomerPhone: [
      { label: '1900.0301', value: '19000301' },
      { label: '0915.915.245', value: '0915915245' },
    ],
    header: {
      userManual: false, // Hướng dẫn sử dụng
      cart: false, // Giỏ hàng
      // noti banner
      bgNotiBanner: '#DE2433',
      textColorNotiBanner: '#FFFFFF',
    },
    statistic: {
      showCardCert: false, // Ẩn phần chữ ký số
      bgBlockOne: ['#E44B58', '#EA757E'],
      bgBlockTwo: ['#EF7E2E', '#EF7E2E'],
      bgBlockThree: ['#556FFD', '#7D90FE'],
    },
    services: {
      invoice: true, // Hóa đơn
      ticket: false, // Vé điện tử
      receipt: false, // biên lai thu phí, lệ phí
      incommingInvoiceProcess: false, // Quản lý hóa đơn đầu vào
      personalIncomeTax: true, // Chứng từ thu nhập cá nhân
      eContract: false, // Hợp đồng điện tử
    },
    systemTab: {
      autoConfig: false, // tắt tab Cấu hình tự động
    },
    footer: {
      isHadFooter: true,
      content: {
        companyName: 'Công ty Cổ phần Công nghệ Go Việt Nam',
        address: 'Số 28 ngõ 8 Cầu Đơ 4, Phường Hà Đông, TP Hà Nội, Việt Nam',
        hotline: '1900.0301',
      },
    },
    invoiceTemplateFooter:
      'Phát hành bởi phần mềm gohoadon.vn - Công ty Cổ phần Công nghệ Go Việt Nam - MST 0111245245',
  },
}
export default BaseConfig
